import { createBrowserClient } from "@pulse-business-ai/auth";

// PKCE prevents code interception in OAuth flows; per-portal storageKey
// isolates session from admin/app on shared origins.
export const supabaseAuth = createBrowserClient({
  url: import.meta.env.VITE_SUPABASE_URL || "https://supabase.pulsebusiness.ai",
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || "not-configured",
  supabase: {
    auth: {
      flowType: "pkce",
      storageKey: "pulse-hub.auth",
    },
  },
});

/** URL of the shared auth portal */
export const AUTH_PORTAL_URL =
  import.meta.env.VITE_AUTH_PORTAL_URL || "https://auth.pulsebusiness.ai";

/** The redirect URI Supabase will call after login */
export const CALLBACK_URL = `${window.location.origin}/callback`;
